import { apiPost, zeigeApiFehler } from '../../lib/api';
import { toast } from '../../lib/toast';
import { confirm } from '../../lib/confirm';

// Welle U3b/U6a: EINE Note-6-Folgefrage — Fehlzeiten-Liste (U3b) und Klassenbuch-Löschen (U6a).
// Fragt je bestätigtem Vorschlag, ob die Note zurückgenommen werden soll. Nie automatisch.
export type BestaetigteNote6 = { vorschlag_id: number; datum: string; fach: string };

function wocheText(iso: string) {
  const x = new Date(iso.slice(0, 10) + 'T12:00:00'); const off = (x.getDay() + 6) % 7;
  const mo = new Date(x); mo.setDate(x.getDate() - off);
  const fr = new Date(mo); fr.setDate(mo.getDate() + 4);
  const f = (y: Date) => `${y.getDate()}.${y.getMonth() + 1}.`;
  return mo.getMonth() === fr.getMonth() ? `${mo.getDate()}.–${f(fr)}` : `${f(mo)}–${f(fr)}`;
}

export async function note6Rueckfrage(liste: BestaetigteNote6[] | undefined, nachher?: () => void) {
  const eindeutig = Array.from(new Map((liste ?? []).map(b => [b.vorschlag_id, b])).values());
  for (const b of eindeutig) {
    const ja = await confirm(
      `Für die Woche ${wocheText(b.datum)} hast du eine Note 6 bestätigt. Sie beruhte auf dieser Fehlzeit. Soll die Note zurückgenommen werden?`,
      { title: `Bestätigte Note 6 in ${b.fach}`, confirmLabel: 'Note 6 zurücknehmen', cancelLabel: 'Note behalten' },
    );
    if (!ja) continue;
    try {
      await apiPost(`/api/mdl-vorschlaege/${b.vorschlag_id}/zuruecknehmen`);
      toast(`Note 6 in ${b.fach} zurückgenommen`, 'success');
      nachher?.();
    } catch (err) { zeigeApiFehler(err, 'Note konnte nicht zurückgenommen werden'); }
  }
}
